import { Divider, Eyebrow } from '@servicetitan/design-system';
import { MessageSessionType } from '../../types/message';
import Message from '../Message/Message';
import datetime from '@lib/utils/datetime';
import strings from './strings';

interface MessageSessionProps {
  session: MessageSessionType;
  isCurrentSession: boolean;
}

const MessageSession = ({ session, isCurrentSession }: MessageSessionProps) => {
  const sessionDate = datetime(session.startedAt).format('ddd MMM D, YYYY');
  return (
    <>
      {isCurrentSession && (
        <Divider>
          <Eyebrow className='m-x-2' size='large'>
            {strings.labels.currentSession}
          </Eyebrow>
        </Divider>
      )}
      <Eyebrow className='ta-center' size='large'>
        {sessionDate}
      </Eyebrow>
      {session.messages.map(({ id, agentId, content, createdAt }) => (
        <Message
          key={id}
          isCustomer={!agentId}
          message={content}
          timestamp={createdAt}
        />
      ))}
    </>
  );
};

export default MessageSession;
